var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoodicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "good_icon",
    "data-name": "good icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 38,
    height: 38,
    fill: "#898989",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16164",
    "data-name": "Group 16164",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28229",
    "data-name": "Path 28229",
    d: "M122.8,24.052a11.776,11.776,0,1,1,11.776-11.776A11.788,11.788,0,0,1,122.8,24.052m0-22.513a10.737,10.737,0,1,0,10.737,10.737A10.746,10.746,0,0,0,122.8,1.539",
    transform: "translate(-110.796 -0.276)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28230",
    "data-name": "Path 28230",
    d: "M122.52,24a11.963,11.963,0,1,1,4.674-.942A12.014,12.014,0,0,1,122.52,24Zm0-23.547A11.547,11.547,0,1,0,134.067,12,11.56,11.56,0,0,0,122.52.453Zm0,22.508A10.961,10.961,0,1,1,133.481,12,10.974,10.974,0,0,1,122.52,22.961Zm0-21.469A10.508,10.508,0,1,0,133.028,12,10.52,10.52,0,0,0,122.52,1.492Z",
    transform: "translate(-110.52 0)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28231",
    "data-name": "Path 28231",
    d: "M131.351,21.7a1.131,1.131,0,1,1-1.131,1.131,1.131,1.131,0,0,1,1.131-1.131",
    transform: "translate(-123.337 -14.124)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_917",
    "data-name": "Ellipse 917",
    d: "M1.355,0A1.355,1.355,0,1,1,0,1.355,1.357,1.357,0,0,1,1.355,0Zm0,2.262a.907.907,0,1,0-.907-.907A.908.908,0,0,0,1.355,2.262Z",
    transform: "translate(6.457 9.826) rotate(-80.783)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28232",
    "data-name": "Path 28232",
    d: "M154.351,21.7a1.131,1.131,0,1,1-1.131,1.131,1.131,1.131,0,0,1,1.131-1.131",
    transform: "translate(-138.364 -14.124)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_918",
    "data-name": "Ellipse 918",
    d: "M1.355,0A1.355,1.355,0,1,1,0,1.355,1.357,1.357,0,0,1,1.355,0Zm0,2.262a.907.907,0,1,0-.907-.907A.908.908,0,0,0,1.355,2.262Z",
    transform: "translate(14.434 9.826) rotate(-80.783)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28233",
    "data-name": "Path 28233",
    d: "M132.327,42.865c-3.77,0-6.807-2.5-6.807-5.551a.524.524,0,0,1,1.047,0c0,2.5,2.583,4.523,5.76,4.523s5.76-2.022,5.76-4.523a.524.524,0,0,1,1.047,0c0,3.05-3.037,5.551-6.807,5.551",
    transform: "translate(-120.327 -23.958)",
    fill: "#898989"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28234",
    "data-name": "Path 28234",
    d: "M132.051,42.814c-3.877,0-7.031-2.591-7.031-5.775a.752.752,0,0,1,1.5,0c0,2.371,2.48,4.3,5.528,4.3s5.528-1.929,5.528-4.3a.752.752,0,0,1,1.5,0C139.083,40.223,135.928,42.814,132.051,42.814Zm-6.28-6.065a.308.308,0,0,0-.3.29c0,2.937,2.949,5.327,6.575,5.327s6.575-2.39,6.575-5.327a.3.3,0,0,0-.59,0,4.291,4.291,0,0,1-1.773,3.375,7.146,7.146,0,0,1-8.422,0,4.29,4.29,0,0,1-1.773-3.375A.308.308,0,0,0,125.772,36.748Z",
    transform: "translate(-120.051 -23.681)",
    fill: "#898989"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodicon);
export default __webpack_public_path__ + "static/media/goodicon.7498f4f2ad274e78758740802e38a35f.svg";
export { ForwardRef as ReactComponent };